const defaultContactUrl = 'https://www.m4cards.com/contact.html';

export default defaultContactUrl;
